import React from 'react';
import { Outlet } from 'react-router-dom';

function PortalScene() {
  return <Outlet />;
}

export default PortalScene;
